export const isError404 = (error: unknown): boolean => {
    return (
        typeof error === 'object' &&
        error !== null &&
        'status' in error &&
        (error as { status: unknown }).status === 404
    );
};
